var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"horizontal":true}},[_c('multiselect',{attrs:{"placeholder":_vm.customPlaceholder,"options":_vm.formOptions,"label":"name","trackBy":"id"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }